import { useState, useEffect } from 'react';
import NeuralHeartSynapse from '../components/NeuralHeartSynapse';

export default function Home() {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('/api/pages/home')
      .then((res) => res.json())
      .then((data) => {
        if (data && typeof data.content === 'string') {
          setContent(data.content);
        }
      })
      .catch(console.error);
  }, []);

  return (
    <div className="home-screen-fit">
      <style>{`
        .home-screen-fit {
          display: flex;
          flex-direction: column;
        }
        .home-screen-fit h1 {
          margin-top: 0;
          margin-bottom: 0.35rem;
          font-size: 1.85rem;
          line-height: 1.2;
          color: #39ff14;
        }
        .home-intro-text {
          color: #39ff14;
          margin-bottom: 0.65rem;
          min-height: 1.5rem;
          line-height: 1.45;
        }
        .home-intro-text p {
          margin: 0.15rem 0;
          color: #39ff14;
        }
        .responsive-terminal {
          position: relative;
          overflow: hidden;
          height: clamp(260px, calc(100dvh - 280px), 440px);
          display: flex;
          flex-direction: column;
          margin-top: 0.25rem;
          margin-bottom: 0;
          border-radius: 6px;
        }
        @media (max-width: 600px) {
          .home-screen-fit h1 {
            font-size: 1.45rem;
          }
          .responsive-terminal {
            height: clamp(240px, calc(100dvh - 250px), 360px);
          }
        }
      `}</style>

      <h1>Welcome to my Terminal</h1>

      <div className="home-intro-text">
        {content
          ? content.split('\n').map((line, i) => <p key={i}>{line}</p>)
          : null}
      </div>

      <div className="terminal-box responsive-terminal">
        <NeuralHeartSynapse />
      </div>
    </div>
  );
}
